import { render } from "./ProfilePopover.vue?vue&type=template&id=68f46d6b"
import script from "./ProfilePopover.vue?vue&type=script&lang=js"
export * from "./ProfilePopover.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__